/**
 * The ready-to-send message for a shared news post (WhatsApp share, Oct 2026;
 * B-52.2, 14 Oct). Pure — no imports — so node --test can run it
 * (newsShareText.test.mjs beside this file). lib/share.js re-exports it.
 *
 * B-62: a members-only post (a team post, or one aimed at staff roles) must
 * not travel in the message itself — strangers can't open it in the app, so
 * they mustn't read it in WhatsApp either. Its message carries NO title and
 * NO body: just who posted, that it's for members, and a sign-in link.
 */

const clip = (s, n) => {
  const t = String(s || '').trim();
  return t.length > n ? `${t.slice(0, n - 1).trimEnd()}…` : t;
};

export function newsShareText(ann, clubName, url) {
  const club = clubName || 'the club';
  if (ann.members_only) {
    return [
      `📣 ${club} posted an update for members.`,
      '',
      'Sign in on Marakin to read it 👇',
      url,
    ].join('\n');
  }
  return [
    `📣 *${ann.title}*`,
    clip(ann.body, 300),
    '',
    `More from ${club} on Marakin 👇`,
    url,
  ].join('\n');
}
